/**
 * Gallery thumbnail slider: scrolls the strip by ~one viewport on prev/next.
 *
 * Initializes any element with [data-gthumbs] that contains:
 *   - [data-gthumbs-viewport]    (the scrolling container)
 *   - [data-gthumbs-prev]        (prev arrow button, optional)
 *   - [data-gthumbs-next]        (next arrow button, optional)
 */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-gthumbs-init') === '1') return;
    var vp = root.querySelector('[data-gthumbs-viewport]');
    var prev = root.querySelector('[data-gthumbs-prev]');
    var next = root.querySelector('[data-gthumbs-next]');
    if (!vp) return;
    root.setAttribute('data-gthumbs-init', '1');

    function update() {
      var max = vp.scrollWidth - vp.clientWidth - 1;
      if (max <= 0) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      if (prev) prev.hidden = vp.scrollLeft <= 0;
      if (next) next.hidden = vp.scrollLeft >= max;
    }

    function scrollByViewport(dir) {
      var amount = Math.max(120, vp.clientWidth * 0.9);
      if (typeof vp.scrollBy === 'function') {
        vp.scrollBy({ left: dir * amount, behavior: 'smooth' });
      } else {
        vp.scrollLeft += dir * amount;
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByViewport(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByViewport(1);
      });
    }
    vp.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    setTimeout(update, 60);

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(update);
      ro.observe(vp);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gthumbs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
